// The company behind the product. Kept in one place because it's a legal entity name — it has to
// read identically everywhere it appears, and the copyright year shouldn't need a yearly edit.
//
// `tone="light"` is for the dark glass login panel, "dark" for the light Control Plane page.

export const KAIROO_LEGAL_NAME = "Kairoo Technologies Private Limited";

export function KairooAttribution({ tone = "dark", className = "" }) {
  const muted = tone === "light" ? "rgba(255,255,255,0.45)" : "var(--scarlet-text-secondary)";
  const strong = tone === "light" ? "rgba(255,255,255,0.72)" : "var(--scarlet-text)";
  return (
    <div className={`text-center ${className}`}>
      <p className="text-[11px] leading-relaxed" style={{ color: muted }}>
        A product of{" "}
        <span className="font-semibold" style={{ color: strong }}>{KAIROO_LEGAL_NAME}</span>
      </p>
      <p className="text-[10px] mt-0.5" style={{ color: muted }}>
        © {new Date().getFullYear()} {KAIROO_LEGAL_NAME}. All rights reserved.
      </p>
    </div>
  );
}
